import React from 'react';
import { HistoryIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
import { ReviveVignette } from './showcase/ReviveVignette';
export function DatabaseReactivation() {
  return <section id="database" aria-labelledby="database-title" className="border-b border-white/5 bg-ink-900" data-id="element-50" data-mp="1zmjz7hjtlz5x">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-51" data-mp="1ungw42nei30l">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-52" data-mp="1pp5jxl9mvgf7">
          <Reveal className="max-w-3xl" data-id="element-53" data-mp="1kyfe66xapbjz">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-54" data-mp="1kwm92w2byze3">
              <HistoryIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-55" data-mp="1guhhs3zcueum" />
            </span>
            <p className="mt-6 text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-56" data-mp="1bveb6f3q80kj">
              Database reactivation
            </p>
            <h2 id="database-title" className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-57" data-mp="11yt83zb9ozjc">
              The leads you already own.
            </h2>
            <p className="mt-6 text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-58" data-mp="2hpvruj3uyl5">
              Most teams&rsquo; next closing is already sitting in their CRM. We re-engage
              your stale database with AI voice and text, surface the ones still in market,
              and book them onto your agents&rsquo; calendars.
            </p>
            <p className="mt-5 border-l-2 border-brand pl-5 font-display text-lg leading-relaxed text-white/85" data-id="element-59" data-mp="ler4nqfs5iud">
              The 48% of leads that never got a second touch are not dead. They are just
              unworked.
            </p>
          </Reveal>

          <Reveal delay={0.1} data-id="element-60" data-mp="bf09rnnb51tr">
            <ReviveVignette data-id="element-61" data-mp="2r7z9pgnxzy2m" />
          </Reveal>
        </div>
      </div>
    </section>;
}